.Main {
    height: 100vh;
}

@media (min-width: 768px) {
    .Main {
        height: 300vh;
    }
}
